import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Multiple approaches to ensure scroll to top works
    
    // Immediate scroll
    window.scrollTo(0, 0);
    
    // Backup with setTimeout for DOM rendering
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }, 0);
    
    // Additional backup with longer delay
    setTimeout(() => {
      if (window.pageYOffset > 0) {
        window.scrollTo(0, 0);
      }
    }, 100);
    
  }, [pathname]);

  return null;
};

export default ScrollToTop;
